__turbopack_context__.v({
  "grid": "FwMyYq_grid",
  "gridItem": "FwMyYq_gridItem",
  "gridItemSpan2": "FwMyYq_gridItemSpan2",
  "gridItemSpan3": "FwMyYq_gridItemSpan3",
  "gridItemSpan4": "FwMyYq_gridItemSpan4",
  "gridItemSpan5": "FwMyYq_gridItemSpan5",
  "gridRowSpan2": "FwMyYq_gridRowSpan2",
  "gridRowSpan3": "FwMyYq_gridRowSpan3",
  "gridRowSpan4": "FwMyYq_gridRowSpan4",
  "gridRowSpan5": "FwMyYq_gridRowSpan5",
  "nested": "FwMyYq_nested",
  "responsive": "FwMyYq_responsive",
});
